/* CCC Relaunch 2027 – Startseite: Öffnungszeiten live, Micra-Farben, «Neu bei uns» automatisch.
   Zeiten kommen aus den Theme-Einstellungen (später aus dem Google-Unternehmensprofil). */
(function () {
  if (window.cccHomeReady) return;
  window.cccHomeReady = true;

  var T = window.ccc27T || {};
  function tr(k, d, v) {
    var s = T[k] || d;
    if (v) Object.keys(v).forEach(function (x) { s = s.split('{' + x + '}').join(v[x]); });
    return s;
  }
  var DAYS = tr('days', 'Sonntag,Montag,Dienstag,Mittwoch,Donnerstag,Freitag,Samstag').split(',');
  function fmtT(lab) { lab = String(lab); return tr('time', '{short} Uhr', { short: lab, hm: lab.indexOf(':') < 0 ? lab + ':00' : lab }); }
  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

  function hoursData() {
    var el = document.getElementById('ccc27-hours');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function zurichNow() {
    var f = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Zurich', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false, weekday: 'short'
    });
    var p = {};
    f.formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    var wd = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 }[p.weekday];
    return { y: +p.year, m: +p.month, d: +p.day, dow: wd, min: (parseInt(p.hour, 10) % 24) * 60 + parseInt(p.minute, 10) };
  }

  function iso(t) { return t.y + '-' + (t.m < 10 ? '0' : '') + t.m + '-' + (t.d < 10 ? '0' : '') + t.d; }

  function addDays(t, k) {
    var dt = new Date(Date.UTC(t.y, t.m - 1, t.d + k));
    return { y: dt.getUTCFullYear(), m: dt.getUTCMonth() + 1, d: dt.getUTCDate(), dow: dt.getUTCDay() };
  }

  function parseSlot(s) {
    if (s === null || s === undefined) return null;
    s = String(s).trim().toLowerCase();
    if (!s || s === 'zu' || s === 'geschlossen' || s === '-') return null;
    var m = s.match(/^(\d{1,2})(?:[:.](\d{2}))?\s*[-–]\s*(\d{1,2})(?:[:.](\d{2}))?$/);
    if (!m) return null;
    function lab(h, mm) { return String(+h) + (mm && mm !== '00' ? ':' + mm : ''); }
    return { a: (+m[1]) * 60 + (+m[2] || 0), b: (+m[3]) * 60 + (+m[4] || 0), from: lab(m[1], m[2]), to: lab(m[3], m[4]) };
  }

  function specials(txt) {
    var o = {};
    String(txt || '').split(/\r?\n/).forEach(function (l) {
      var m = l.trim().match(/^(\d{4}-\d{2}-\d{2})\s+(.+)$/);
      if (m) o[m[1]] = m[2].trim();
    });
    return o;
  }

  function slotFor(loc, day, sp) {
    var k = iso(day);
    return parseSlot(Object.prototype.hasOwnProperty.call(sp, k) ? sp[k] : (loc.week || [])[day.dow]);
  }

  function status(loc) {
    var t = zurichNow();
    var sp = specials(loc.special);
    var today = slotFor(loc, t, sp);
    if (today && t.min >= today.a && t.min < today.b) return { open: true, until: today.to };
    if (today && t.min < today.a) return { open: false, w: 'today', at: today.from };
    for (var k = 1; k <= 14; k++) {
      var d = addDays(t, k);
      var s = slotFor(loc, d, sp);
      if (s) return { open: false, w: k === 1 ? 'tomorrow' : 'day', dow: d.dow, at: s.from };
    }
    return { open: false };
  }

  function whenText(st) {
    if (st.w === 'today') return tr('today', 'heute');
    if (st.w === 'tomorrow') return tr('tomorrow', 'morgen');
    return tr('on_day', 'am {day}', { day: DAYS[st.dow] });
  }
  function nextText(st) { return st.at ? tr('opens', 'öffnet {when} um {t}', { when: whenText(st), t: fmtT(st.at) }) : tr('closed', 'geschlossen'); }

  function renderHours() {
    var D = hoursData();
    if (!D) return;
    var small = window.matchMedia('(max-width: 749px)').matches;
    document.querySelectorAll('[data-ccc-open]').forEach(function (el) {
      var key = el.getAttribute('data-ccc-open');
      var fmt = el.getAttribute('data-ccc-format') || 'short';
      var txt = '';
      var isOpen = false;
      if (key === 'all') {
        var parts = [];
        var allOpen = true;
        Object.keys(D).forEach(function (k) {
          var L = D[k];
          var st = status(L);
          var nm = small ? (L.short || L.name) : L.name;
          if (st.open) { isOpen = true; parts.push({ nm: nm, open: true, t: fmtT(st.until) }); }
          else { allOpen = false; parts.push({ nm: nm, open: false, t: nextText(st) }); }
        });
        if (allOpen) txt = tr('open_today', 'Heute offen') + ': ' + parts.map(function (p) { return p.nm + ' ' + tr('until', 'bis {t}', { t: p.t }); }).join(' · ');
        else txt = parts.map(function (p) { return p.nm + ' ' + (p.open ? tr('open_until', 'offen bis {t}', { t: p.t }) : p.t); }).join(' · ');
        if (fmt === 'any') txt = isOpen ? tr('open_today', 'Heute offen') : tr('closed_now', 'Gerade geschlossen');
      } else if (D[key]) {
        var st1 = status(D[key]);
        isOpen = st1.open;
        var nt = nextText(st1);
        txt = cap(st1.open ? tr('open_until', 'offen bis {t}', { t: fmtT(st1.until) }) : nt);
      } else {
        return;
      }
      el.innerHTML = '<span class="ccc27-dot" aria-hidden="true"></span>';
      el.appendChild(document.createTextNode(txt));
      el.classList.toggle('is-closed', !isOpen);
    });
  }

  /* Micra-Farben: Punkt anklicken zeigt die Variante */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ccc-swatch]');
    if (!b) return;
    e.preventDefault();
    var card = b.closest('[data-ccc-farben]');
    if (!card) return;
    var img = card.querySelector('[data-ccc-look-link] img');
    if (img && b.getAttribute('data-img')) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = b.getAttribute('data-img');
      img.alt = b.getAttribute('data-alt') || img.alt;
      card.classList.add('is-variant');
    }
    var a = card.querySelector('[data-ccc-look-link]');
    if (a && b.getAttribute('data-url')) a.href = b.getAttribute('data-url');
    card.querySelectorAll('[data-ccc-swatch]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
  });

  /* Neu bei uns: die neuesten Produkte direkt aus dem Shop */
  function loadNew() {
    document.querySelectorAll('[data-ccc-new-feed]').forEach(function (box) {
      var url = box.getAttribute('data-ccc-new-feed');
      var n = parseInt(box.getAttribute('data-count'), 10) || 4;
      var ex = (box.getAttribute('data-exclude') || '').toLowerCase().split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        if (!html) return;
        var week = box.querySelector('[data-ccc-new-week]');
        if (week) countNew(url, ex, week, html);
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = [].slice.call(doc.querySelectorAll('[data-ccc-card]')).filter(function (c) {
          var tags = (c.getAttribute('data-tags') || '').toLowerCase().split('|');
          return !ex.some(function (t) { return tags.indexOf(t) > -1; });
        }).slice(0, n);
        if (!cards.length) return;
        var grid = box.querySelector('[data-ccc-new-grid]');
        grid.innerHTML = '';
        cards.forEach(function (c) { grid.appendChild(document.importNode(c, true)); });
        var badge = box.querySelector('[data-ccc-new-badge]');
        if (badge) {
          var newest = Math.max.apply(null, cards.map(function (c) { return +c.getAttribute('data-created') || 0; }));
          badge.hidden = !(Date.now() / 1000 - newest < 7 * 86400);
        }
      }).catch(function () {});
    });
  }

  /* 2026-10-04 Zähler «Neuheiten in den letzten 7 Tagen»: zählt im Neu-Feed (neueste zuerst) alle Produkte,
     die jünger als 7 Tage sind, ohne die ausgeschlossenen Tags; blättert weiter, solange die Seite nur Neues enthält. */
  function countNew(url, ex, el, firstHtml) {
    var cutoff = Date.now() / 1000 - 7 * 86400, total = 0, page = 1;
    function step(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var cards = [].slice.call(doc.querySelectorAll('[data-ccc-card]'));
      var oldest = Infinity;
      cards.forEach(function (c) {
        var t = +c.getAttribute('data-created') || 0;
        if (t < oldest) oldest = t;
        if (t >= cutoff) {
          var tags = (c.getAttribute('data-tags') || '').toLowerCase().split('|');
          if (!ex.some(function (x) { return tags.indexOf(x) > -1; })) total++;
        }
      });
      if (cards.length && oldest >= cutoff && page < 10) {
        page++;
        return fetch(url + '&page=' + page, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (h) { if (h) return step(h); show(); });
      }
      show();
    }
    function show() {
      if (total > 0) { el.querySelector('[data-n]').textContent = total; el.hidden = false; }
    }
    try { step(firstHtml); } catch (e) {}
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    renderHours();
    loadNew();
    setInterval(renderHours, 5 * 60 * 1000);
  });

  document.addEventListener('shopify:section:load', function () { renderHours(); loadNew(); });
})();
